import request from '@/utils/request'

/**
 * 查询金币交易记录
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function queryGoldBusiness(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/goldBusiness/queryGoldBusiness',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}